import { IconName } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { motion } from 'framer-motion';
import { AnimTap, EColors2, EVariables } from 'libs/styles/styling';
import styled, { css } from 'styled-components/macro';

interface Props {
    iconName: IconName;
    onClick: () => void;
    backgroundColor?: string;
    color?: string;
    disabled?: boolean;

    className?: string;
}

export const IconButton = (props: Props): JSX.Element => {
    const anim = props.disabled ? {} : AnimTap;

    return (
        <S_IconButton
            className={props.className}
            onClick={props.onClick}
            {...anim}
            $disabled={props.disabled}
        >
            <S_Circle $backgroundColor={props.backgroundColor ?? EColors2.DARK}>
                <S_Icon $color={props.color ?? 'white'} icon={['far', props.iconName]} />
            </S_Circle>
        </S_IconButton>
    );
};

const S_IconButton = styled(motion.div)<{ $disabled: boolean }>`
    height: 36px;
    width: 36px;
    flex-grow: 0;
    flex-shrink: 0;
    display: flex;
    background-color: #fafcfe;
    border-radius: ${EVariables.Radius1};
    align-items: center;
    cursor: pointer;
    ${(props) => {
        if (props.$disabled) {
            return css`
                cursor: not-allowed;
            `;
        }
    }}
`;

const S_Circle = styled.div<{ $backgroundColor: string }>`
    width: 100%;
    height: 100%;
    border-radius: 100%;
    background-color: ${(props) => props.$backgroundColor};
    display: flex;
    justify-content: center;
    align-items: center;
`;

const S_Icon = styled(FontAwesomeIcon)<{ $color: string }>`
    font-size: 16px;
    color: ${(props) => props.$color};
`;
